import React, { useState, useEffect, useMemo } from "react";
import "./styles/BackupCodes.css"; // ✅ Import styles

import { useLocation } from "react-router-dom";
import SEO from "../seo/SEO";
import config from "../config/config";

const BackupCodes = () => {
  const location = useLocation();
  const backupCodes = useMemo(() => location.state?.backupCodes || [], [location.state?.backupCodes]);
  const [errorMessage, setErrorMessage] = useState("");

  useEffect(() => {
    if (!backupCodes.length) {
      setErrorMessage("Backup codes are not available. Generate new ones if needed.");
    }
  }, [backupCodes]);

  const handleGoBack = () => {
    window.location.href = "/user/profile";
  };

  return (
    <>
        <SEO
            title="Backup Codes - Withrow Knives"
            description="Your Two-Factor Authentication backup codes. Store them securely in case you lose access to your authentication device."
            url={`${config.metadata.siteUrl}/user/backup-codes`}
            robots="noindex, nofollow"
        />


      <div className="backup-codes-container">
        <h2>Backup Codes</h2>

        {/* ✅ Live Error Announcements for Screen Readers */}
        {errorMessage && <p className="error" role="alert" aria-live="polite">{errorMessage}</p>}

        {/* ✅ Backup Codes Section */}
        {backupCodes.length > 0 && (
          <>
            <p>Save these codes somewhere safe. Each code can be used only once.</p>

            {/* ✅ Backup Codes List - Readable by Assistive Tech */}
            <ul aria-live="polite">
              {backupCodes.map((code, index) => (
                <li key={index}>
                  <strong>{code}</strong>
                </li>
              ))}
            </ul>

            {/* ✅ Confirmation Button */}
            <button onClick={handleGoBack} aria-describedby="backup-instruction">
              I Have Saved My Codes
            </button>

            {/* ✅ Hidden SR-Only Instruction for Assistive Tech */}
            <p id="backup-instruction" className="sr-only">
              Clicking this button confirms you have saved your backup codes.
            </p>
          </>
        )}
      </div>
    </>
  );
};


export default BackupCodes;
